import { clearDatePublished } from './datePublished'
import { clearDesigners } from './designers'
import { clearFileTypes } from './fileTypes'
import { clearKeyword } from './keyword'
import { clearContentSafetyLicenses, clearLicenses } from './licenses'
import { clearMoreFilters } from './moreFilters'
import { clearPolygon } from './polygon'
import { clearPricing } from './pricing'
import { clearQualityContent } from './qualityContent'
import { clearSimulationReady } from './simulationReady'
import { clearSize } from './size'
import { clearSortBy } from './sortBy'
import { clearStyles } from './styles'
import { clearTags } from './tags'
import { clearThreeDOnly } from './threeDOnly'
import { clearThreeDprintOnly } from './threeDPrintOnly'

/**
 * Clears all main filters
 */
const clearMainFilters = () => {
  clearFileTypes()
  clearQualityContent()
  clearPricing()
  clearDatePublished()
  clearDesigners()
  clearLicenses()
  clearMoreFilters()
  clearKeyword()
}

/**
 * Clears all secondary filters
 */
const clearSecondaryFilters = () => {
  // common filters
  clearStyles()
  clearTags()
  clearSimulationReady()

  // 3D Only filters
  clearPolygon()
  clearThreeDOnly()

  // 3D Print Only filters
  clearThreeDprintOnly()
  clearSize()
}

/**
 * Clears all filters
 */
export const clearAllFilters = () => {
  clearMainFilters()
  clearSecondaryFilters()
  // Clear all is the only control that drops the hidden route-default content safety tokens.
  clearContentSafetyLicenses()
  // Reset the sort back to Best Match too, so the Top Sellers/New/Trending chips and the
  // Sorting dropdown clear along with the filters.
  clearSortBy()
}
